import React, { useCallback } from 'react';
import { AppRemixIcon } from '@/layout/AppComponents';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { axiosPath, path } from '../../../../../../../routing/helpers/router';
import ErrorHandler from '../../../../../../components/error/ErrorHandler';
import colors from '../../../../../../../constants/colors';
import * as currentPageAction from '../../../../../../../store/actions/currentPageAction';

export default function ObligationAssociation(props) {
  const { plantObligationID, description = '' } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const poLevel3 = useSelector(
    (state) => state.currentPage?.plantObligationLevels?.level3
  );

  // > TOGGLE TAG
  const toggleIcon = useCallback(async () => {
    await axios
      .post(
        axiosPath(
          "api_r_user_module_legalCompliance_evaluation_obligationAssociation_toggle"
        ),
        { moduleBridgeHex, plantHex, plantObligationID }
      )
      .then((response) => {
        dispatch(
          currentPageAction.change("auxSidebar", { opened: "blockChange" })
        );
        navigate(
            path({
              name: "user_module_legalCompliance_evaluation",
              params: {
                moduleBridgeHex,
                plantHex,
                page: 1,
                filtersHex: response.data.hexCode,
              },
            })
        );
      })
      .catch((e) => {
        dispatch(ErrorHandler(e, history));
      });
  },
    [plantObligationID, moduleBridgeHex, plantHex, poLevel3]);
  // < TOGGLE TAG

  return (
    <>
      <AppRemixIcon
        onClick={() => toggleIcon()}
        icon="color-filter"
        title={description}
        color={colors.primary}
        filled
        className="pointer"
      />
    </>
  );
}
